interface ClassNameObj {
    [name: string]: boolean | undefined | null;
}

export function className(...params: (string | ClassNameObj)[]) {
    const res: string[] = [];

    for (let param of params) {
        if (typeof param === 'string') {
            res.push(param);
        } else if (typeof param === 'object') {
            const keys = Object.keys(param).filter(key => (param as ClassNameObj)[key]);
            if (keys.length) {
                res.push(...keys);
            }
        }
    }

    return res.join(' ');
}
